const DownArrowSvg = ({referencia, inResponsiveNavMenu}) => {
  return (
		<svg
			ref={referencia}
			width="10"
			height="5"
			viewBox="0 0 10 5"
			xmlns="http://www.w3.org/2000/svg"
			className={`${!inResponsiveNavMenu ? "page-header--svg" : "responsiveNavMenu--svg"}`}
		>
			<path d="M4.99951 3.45891L1.82051 0.27791C1.70766 0.165325 1.55471 0.10218 1.39531 0.102368C1.2359 0.102555 1.0831 0.166059 0.970513 0.278909C0.857929 0.391759 0.794785 0.544711 0.794972 0.704116C0.79516 0.863522 0.858665 1.01633 0.971514 1.12891L4.57151 4.72891C4.68082 4.83803 4.82799 4.9008 4.9824 4.90416C5.13682 4.90751 5.28658 4.85119 5.40051 4.74691L9.02951 1.13191C9.14236 1.01932 9.20587 0.866522 9.20605 0.707117C9.20624 0.547711 9.1431 0.394759 9.03051 0.281909C8.91793 0.16906 8.76513 0.105556 8.60572 0.105368C8.44631 0.105181 8.29336 0.168324 8.18051 0.280909L4.99951 3.45891Z" />
		</svg>
	);
}

export default DownArrowSvg

